var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignstudiologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 57.978,
    viewBox: "0 0 350 57.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #606060;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #606060;\r\n        stroke-linecap: round;\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-3, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-4, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-5, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-6, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-7, .cls-70, .cls-9 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #f08201;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #f07e25;\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #f07f25;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #f08025;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #f08125;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #f08225;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #f08325;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #f18425;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #f18524;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #f18624;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #f18724;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #f18824;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #f18924;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #f28924;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #f28a24;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #f28b24;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #f28c24;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #f28d24;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #f28e24;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #f38f24;\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #f39024;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #f39124;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #f39224;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: #f39324;\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #f49424;\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: #f49524;\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: #f49624;\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: #f49724;\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: #f49824;\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: #f49823;\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: #f59923;\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: #f59a23;\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: #f59b23;\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: #f59c23;\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: #f59d23;\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: #f69e23;\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: #f69f23;\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: #f6a023;\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: #f6a123;\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: #f6a223;\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: #f6a322;\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: #f7a422;\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: #f7a522;\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: #f7a622;\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: #f7a722;\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: #f7a822;\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: #f8a822;\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: #f8a922;\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: #f8aa22;\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: #f8ab22;\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: #f8ac21;\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: #f8ad21;\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: #f9ae21;\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: #f9af21;\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: #f9b021;\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: #f9b121;\r\n      }\r\n\r\n      .cls-63 {\r\n        fill: #f9b221;\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: #fab221;\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: #fab321;\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: #fab421;\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: #fab521;\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: #fab520;\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: #fab620;\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: #fab720;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15599f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#36b6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.001,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6484",
    "data-name": "Path 6484",
    d: "M41.084,62.906A28.543,28.543,0,0,1,12.5,34.322V32.489a5.561,5.561,0,0,1,4.642-2.565,5.06,5.06,0,0,1,4.642,3.237v1.4a19.3,19.3,0,1,0,38.6,0A18.73,18.73,0,0,0,55.5,21.8,4.807,4.807,0,0,1,57.575,16a4.324,4.324,0,0,1,4.642-.489,28.466,28.466,0,0,1-21.133,47.4",
    transform: "translate(-12.5 -15.055)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10895",
    "data-name": "Group 10895",
    transform: "translate(-21 -15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8180",
    "data-name": "Group 8180",
    transform: "translate(21 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7087",
    "data-name": "Path 7087",
    className: "cls-1",
    d: "M17.227,15.92q0,4.959-2.6,7.5t-7.641,2.54H2.269V6.258H7.592q4.716,0,7.176,2.466T17.227,15.92Zm-1.5.054q0-4.231-2.149-6.367T7.269,7.471H3.644V24.747H6.9Q15.731,24.747,15.731,15.974Zm16.791,9.985H21.755V6.258H32.522V7.525H23.129v7.452H32v1.267H23.129v8.449h9.392Zm15.335-5.08a4.729,4.729,0,0,1-1.812,3.908,7.516,7.516,0,0,1-4.818,1.442,15.091,15.091,0,0,1-5.538-.8V24.059a14.014,14.014,0,0,0,5.431.9,6.085,6.085,0,0,0,3.847-1.112,3.527,3.527,0,0,0,1.422-2.917,3.367,3.367,0,0,0-.472-1.853,4.3,4.3,0,0,0-1.536-1.341,18.944,18.944,0,0,0-3.126-1.307,10.7,10.7,0,0,1-4.171-2.244,4.459,4.459,0,0,1-1.152-3.214,4.417,4.417,0,0,1,1.732-3.6,6.877,6.877,0,0,1,4.454-1.395,13.036,13.036,0,0,1,5.215,1.051l-.5,1.186a12.164,12.164,0,0,0-4.69-1.024A5.5,5.5,0,0,0,38.667,8.2a3.3,3.3,0,0,0-1.294,2.749,3.6,3.6,0,0,0,.4,1.792,3.655,3.655,0,0,0,1.3,1.26,17.8,17.8,0,0,0,3.1,1.341,16.708,16.708,0,0,1,3.463,1.543,4.95,4.95,0,0,1,1.691,1.7A4.634,4.634,0,0,1,47.857,20.879Zm4.164,5.08V6.258H53.4v19.7Zm14.7-9.931h7.263v8.988a16.3,16.3,0,0,1-6.428,1.213q-4.663,0-7.149-2.634t-2.486-7.459a11.2,11.2,0,0,1,1.233-5.33,8.637,8.637,0,0,1,3.531-3.591,10.747,10.747,0,0,1,5.276-1.267,13.6,13.6,0,0,1,5.781,1.186l-.553,1.24a12.5,12.5,0,0,0-5.309-1.186A8.116,8.116,0,0,0,61.7,9.593a9.035,9.035,0,0,0-2.284,6.488q0,4.447,2.17,6.691t6.374,2.244a12.347,12.347,0,0,0,4.622-.768V17.322H66.723Zm26.533,9.931H91.868L80.2,8.468h-.108q.162,3.126.162,4.716V25.959H78.932V6.258h1.375L91.963,23.723h.081q-.121-2.426-.121-4.609V6.258h1.334ZM13.144,51.969a4.729,4.729,0,0,1-1.812,3.908,7.516,7.516,0,0,1-4.818,1.442,15.091,15.091,0,0,1-5.538-.8V55.149a14.014,14.014,0,0,0,5.431.9,6.085,6.085,0,0,0,3.847-1.112,3.527,3.527,0,0,0,1.422-2.917A3.367,3.367,0,0,0,11.2,50.17a4.3,4.3,0,0,0-1.536-1.341,18.945,18.945,0,0,0-3.126-1.307A10.7,10.7,0,0,1,2.37,45.278a4.807,4.807,0,0,1,.579-6.819A6.877,6.877,0,0,1,7.4,37.065a13.036,13.036,0,0,1,5.215,1.051l-.5,1.186a12.164,12.164,0,0,0-4.69-1.024,5.5,5.5,0,0,0-3.477,1.011A3.3,3.3,0,0,0,2.66,42.037a3.6,3.6,0,0,0,.4,1.792,3.655,3.655,0,0,0,1.3,1.26,17.8,17.8,0,0,0,3.1,1.341,16.708,16.708,0,0,1,3.463,1.543,4.95,4.95,0,0,1,1.691,1.7A4.634,4.634,0,0,1,13.144,51.969Zm9.3,5.08H21.054V38.641h-6.4V37.348h14.19v1.294h-6.4Zm23.811-19.7V50.1A7.063,7.063,0,0,1,44.286,55.4,7.536,7.536,0,0,1,38.8,57.319a7.222,7.222,0,0,1-5.343-1.92,7.241,7.241,0,0,1-1.92-5.357V37.348h1.388V50.1a5.492,5.492,0,0,0,6.037,6.01,5.392,5.392,0,0,0,5.916-5.875V37.348ZM66.575,47.01q0,4.959-2.6,7.5t-7.641,2.54H51.617v-19.7H56.94q4.716,0,7.176,2.466T66.575,47.01Zm-1.5.054q0-4.231-2.149-6.367t-6.313-2.136H52.991V55.836h3.261Q65.079,55.836,65.079,47.064ZM71.1,57.049v-19.7h1.375v19.7Zm23.515-9.878a11,11,0,0,1-2.345,7.418,9.015,9.015,0,0,1-12.923,0A11.047,11.047,0,0,1,77,47.144a10.858,10.858,0,0,1,2.365-7.4,8.144,8.144,0,0,1,6.462-2.7,8.054,8.054,0,0,1,6.455,2.715A11.014,11.014,0,0,1,94.617,47.171Zm-16.117,0a10.092,10.092,0,0,0,1.887,6.542,7.551,7.551,0,0,0,10.855.02q1.88-2.291,1.88-6.563t-1.88-6.529a7.574,7.574,0,0,0-10.834.02A9.909,9.909,0,0,0,78.5,47.171Z",
    transform: "translate(255.383 -2.944)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1045",
    "data-name": "Line 1045",
    className: "cls-2",
    y2: 57.078,
    transform: "translate(244.843 0.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10065",
    "data-name": "Group 10065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    className: "cls-3",
    d: "M352.485,35.358a12.244,12.244,0,0,1,.914,4.634,16.065,16.065,0,0,1-6.95,13.474c-9.023,5.792-20.851,4.634-27.618-3.719a16.844,16.844,0,0,1-3.231-9.511,4.8,4.8,0,0,1,4.634-4.634c7.865,0,.914,12.5,14.144,12.5,6.28,0,11.157-4.146,7.865-10.913a4.852,4.852,0,0,1-.671-2.317c0-2.073,1.158-3.475,3.475-4.39,3.536-1.341,6.1,2.317,7.438,4.877M316.576,21.7a12.244,12.244,0,0,1-.915-4.634,16.065,16.065,0,0,1,6.95-13.474c9.023-5.792,20.851-4.634,27.618,3.719a16.989,16.989,0,0,1,3.231,9.755,4.8,4.8,0,0,1-4.633,4.634c-7.865,0-.915-12.5-14.144-12.5-6.28,0-11.157,4.146-7.865,10.913a4.853,4.853,0,0,1,.671,2.317c0,2.073-1.158,3.475-3.475,4.39C320.478,27.981,317.734,24.018,316.576,21.7Zm17.863,1.646a5.121,5.121,0,1,1-5.121,5.121A5.319,5.319,0,0,1,334.439,23.347Z",
    transform: "translate(-120.823 0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    className: "cls-4",
    d: "M209.072,56.786a4.426,4.426,0,0,0,2.572.49,5.994,5.994,0,0,0,3-1.653c.245-.245.245-.49.49-.674l20.026-39.806L245.633,35.6a4.334,4.334,0,0,0,4.165,2.572,4.534,4.534,0,0,0,3.981-2.327,4.366,4.366,0,0,0,0-4.409L239.57,3.017A4.823,4.823,0,0,0,235.406.2a4.75,4.75,0,0,0-4.164,2.817L206.99,50.54a5.167,5.167,0,0,0-.49,2.572,4.807,4.807,0,0,0,2.572,3.674m50.033-9.064a4.654,4.654,0,1,1-4.654,4.654A4.434,4.434,0,0,1,259.106,47.723Z",
    transform: "translate(-83.127 -0.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    className: "cls-5",
    d: "M133.542.181a4.64,4.64,0,0,1,4.642,4.642v9.772a4.642,4.642,0,1,1-9.284,0V4.578a4.6,4.6,0,0,1,4.642-4.4m0,37.868a4.64,4.64,0,0,1,4.642,4.642v9.772a4.642,4.642,0,1,1-9.284,0V42.691A4.64,4.64,0,0,1,133.542,38.049Zm0-13.926a4.642,4.642,0,1,1-4.642,4.642A4.491,4.491,0,0,1,133.542,24.123Zm10.689-1.4a4.572,4.572,0,0,0,6.535,0L165.607,8.06a4.572,4.572,0,0,0,0-6.535,4.572,4.572,0,0,0-6.535,0L144.23,16.183A4.468,4.468,0,0,0,144.23,22.718Zm0,11.849a4.572,4.572,0,0,1,6.535,0l14.842,14.659a4.621,4.621,0,0,1-6.535,6.535L144.23,41.1A4.469,4.469,0,0,1,144.23,34.567Z",
    transform: "translate(-57.932 -0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    className: "cls-6",
    d: "M41.084,62.906A28.543,28.543,0,0,1,12.5,34.322V32.489a5.561,5.561,0,0,1,4.642-2.565,5.06,5.06,0,0,1,4.642,3.237v1.4a19.3,19.3,0,1,0,38.6,0A18.73,18.73,0,0,0,55.5,21.8,4.807,4.807,0,0,1,57.575,16a4.324,4.324,0,0,1,4.642-.489,28.466,28.466,0,0,1-21.133,47.4",
    transform: "translate(-12.497 -5.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    className: "cls-7",
    d: "M40.838,0A28.543,28.543,0,0,1,69.422,28.584v1.832a5.173,5.173,0,0,1-4.4,2.81,5.06,5.06,0,0,1-4.642-3.237v-1.4a19.3,19.3,0,1,0-38.6,0A18.73,18.73,0,0,0,26.668,41.35a5.381,5.381,0,0,1-2.077,5.8A5.289,5.289,0,0,1,19.7,47.4,28.8,28.8,0,0,1,12.5,28.584,28.183,28.183,0,0,1,40.838,0",
    transform: "translate(-12.494 0.001)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9137",
    "data-name": "Group 9137",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6483",
    "data-name": "Path 6483",
    className: "cls-7",
    d: "M34.316,97.96,32.3,93.99,87.27,66.2l2.016,4.031",
    transform: "translate(-20.207 -34.962)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9138",
    "data-name": "Group 9138",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6485",
    "data-name": "Path 6485",
    className: "cls-7",
    d: "M32.222,93.974l-.122-.244L87.131,66l.122.244",
    transform: "translate(-20.129 -34.884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9139",
    "data-name": "Group 9139",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6487",
    "data-name": "Path 6487",
    className: "cls-7",
    d: "M32.122,93.735,32,93.49,87.031,65.7l.122.244",
    transform: "translate(-20.09 -34.767)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9140",
    "data-name": "Group 9140",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6489",
    "data-name": "Path 6489",
    className: "cls-9",
    d: "M31.922,93.435,31.8,93.19,86.831,65.4l.122.244",
    transform: "translate(-20.012 -34.65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9141",
    "data-name": "Group 9141",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6491",
    "data-name": "Path 6491",
    className: "cls-9",
    d: "M31.822,93.135,31.7,92.89,86.731,65.1l.122.305",
    transform: "translate(-19.973 -34.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9142",
    "data-name": "Group 9142",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    className: "cls-10",
    d: "M31.722,92.874l-.122-.244L86.57,64.9l.122.244",
    transform: "translate(-19.934 -34.456)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9143",
    "data-name": "Group 9143",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    className: "cls-11",
    d: "M31.522,92.635l-.122-.305L86.431,64.6l.122.244",
    transform: "translate(-19.856 -34.339)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9144",
    "data-name": "Group 9144",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    className: "cls-11",
    d: "M31.422,92.335,31.3,92.09,86.331,64.3l.122.244",
    transform: "translate(-19.817 -34.222)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9145",
    "data-name": "Group 9145",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    className: "cls-12",
    d: "M31.222,92.035,31.1,91.79,86.131,64l.122.244",
    transform: "translate(-19.74 -34.105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9146",
    "data-name": "Group 9146",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    className: "cls-13",
    d: "M31.122,91.735,31,91.49,86.031,63.7l.122.305",
    transform: "translate(-19.701 -33.989)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9147",
    "data-name": "Group 9147",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    className: "cls-13",
    d: "M31.022,91.474l-.122-.244L85.87,63.5l.122.244",
    transform: "translate(-19.662 -33.911)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9148",
    "data-name": "Group 9148",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    className: "cls-14",
    d: "M30.822,91.235,30.7,90.99,85.731,63.2l.122.244",
    transform: "translate(-19.584 -33.794)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9149",
    "data-name": "Group 9149",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    className: "cls-14",
    d: "M30.722,90.935,30.6,90.69,85.631,62.9l.122.244",
    transform: "translate(-19.545 -33.677)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9150",
    "data-name": "Group 9150",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    className: "cls-14",
    d: "M30.522,90.635,30.4,90.39,85.431,62.6l.122.305",
    transform: "translate(-19.467 -33.561)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9151",
    "data-name": "Group 9151",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6511",
    "data-name": "Path 6511",
    className: "cls-15",
    d: "M30.422,90.374l-.122-.244L85.331,62.4l.122.244",
    transform: "translate(-19.428 -33.483)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9152",
    "data-name": "Group 9152",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    className: "cls-15",
    d: "M30.322,90.135l-.122-.305L85.17,62.1l.122.244",
    transform: "translate(-19.389 -33.366)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9153",
    "data-name": "Group 9153",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    className: "cls-16",
    d: "M30.122,89.835,30,89.59,85.031,61.8l.122.244",
    transform: "translate(-19.311 -33.249)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9154",
    "data-name": "Group 9154",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    className: "cls-17",
    d: "M30.022,89.535,29.9,89.29,84.931,61.5l.122.244",
    transform: "translate(-19.273 -33.132)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9155",
    "data-name": "Group 9155",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    className: "cls-17",
    d: "M29.822,89.273l-.122-.244L84.731,61.3l.122.244",
    transform: "translate(-19.195 -33.055)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9156",
    "data-name": "Group 9156",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    className: "cls-18",
    d: "M29.722,89.035l-.122-.305L84.631,61l.122.244",
    transform: "translate(-19.156 -32.938)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9157",
    "data-name": "Group 9157",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    className: "cls-18",
    d: "M29.622,88.735,29.5,88.49,84.47,60.7l.122.244",
    transform: "translate(-19.117 -32.821)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9158",
    "data-name": "Group 9158",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    className: "cls-19",
    d: "M29.422,88.435,29.3,88.19,84.331,60.4l.122.244",
    transform: "translate(-19.039 -32.704)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9159",
    "data-name": "Group 9159",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    className: "cls-20",
    d: "M29.322,88.135,29.2,87.89,84.231,60.1l.122.305",
    transform: "translate(-19 -32.587)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9160",
    "data-name": "Group 9160",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    className: "cls-20",
    d: "M29.122,87.874,29,87.629,84.031,59.9l.122.244",
    transform: "translate(-18.922 -32.51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9161",
    "data-name": "Group 9161",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    className: "cls-21",
    d: "M29.022,87.635l-.122-.305L83.931,59.6l.122.244",
    transform: "translate(-18.883 -32.393)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9162",
    "data-name": "Group 9162",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    className: "cls-22",
    d: "M28.922,87.335,28.8,87.09,83.77,59.3l.122.244",
    transform: "translate(-18.844 -32.276)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9163",
    "data-name": "Group 9163",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    className: "cls-22",
    d: "M28.722,87.035,28.6,86.79,83.631,59l.122.244",
    transform: "translate(-18.767 -32.159)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9164",
    "data-name": "Group 9164",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    className: "cls-23",
    d: "M28.622,86.774l-.122-.244L83.531,58.8l.122.244",
    transform: "translate(-18.728 -32.081)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9165",
    "data-name": "Group 9165",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    className: "cls-23",
    d: "M28.422,86.535l-.122-.305L83.331,58.5l.122.244",
    transform: "translate(-18.65 -31.965)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9166",
    "data-name": "Group 9166",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    className: "cls-24",
    d: "M28.322,86.235,28.2,85.99,83.231,58.2l.122.244",
    transform: "translate(-18.611 -31.848)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9167",
    "data-name": "Group 9167",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    className: "cls-25",
    d: "M28.222,85.935,28.1,85.69,83.07,57.9l.122.244",
    transform: "translate(-18.572 -31.731)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9168",
    "data-name": "Group 9168",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    className: "cls-25",
    d: "M28.022,85.635,27.9,85.39,82.931,57.6l.122.305",
    transform: "translate(-18.494 -31.614)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9169",
    "data-name": "Group 9169",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    className: "cls-25",
    d: "M27.922,85.374l-.122-.244L82.831,57.4l.122.244",
    transform: "translate(-18.455 -31.537)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9170",
    "data-name": "Group 9170",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    className: "cls-25",
    d: "M27.722,85.135,27.6,84.89,82.631,57.1l.122.244",
    transform: "translate(-18.377 -31.42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9171",
    "data-name": "Group 9171",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    className: "cls-26",
    d: "M27.622,84.835,27.5,84.59,82.531,56.8l.122.244",
    transform: "translate(-18.338 -31.303)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9172",
    "data-name": "Group 9172",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    className: "cls-27",
    d: "M27.522,84.535,27.4,84.29,82.37,56.5l.122.305",
    transform: "translate(-18.299 -31.186)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9173",
    "data-name": "Group 9173",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    className: "cls-27",
    d: "M27.322,84.274l-.122-.244L82.231,56.3l.122.244",
    transform: "translate(-18.222 -31.108)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9174",
    "data-name": "Group 9174",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    className: "cls-28",
    d: "M27.222,84.035l-.122-.305L82.131,56l.122.244",
    transform: "translate(-18.183 -30.992)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9175",
    "data-name": "Group 9175",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    className: "cls-29",
    d: "M27.022,83.735,26.9,83.49,81.931,55.7l.122.244",
    transform: "translate(-18.105 -30.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9176",
    "data-name": "Group 9176",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    className: "cls-29",
    d: "M26.922,83.435,26.8,83.19,81.831,55.4l.122.244",
    transform: "translate(-18.066 -30.758)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9177",
    "data-name": "Group 9177",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    className: "cls-30",
    d: "M26.822,83.135,26.7,82.89,81.67,55.1l.122.305",
    transform: "translate(-18.027 -30.641)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9178",
    "data-name": "Group 9178",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    className: "cls-30",
    d: "M26.622,82.874l-.122-.244L81.531,54.9l.122.244",
    transform: "translate(-17.949 -30.563)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9179",
    "data-name": "Group 9179",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    className: "cls-30",
    d: "M26.522,82.635,26.4,82.39,81.431,54.6l.122.244",
    transform: "translate(-17.91 -30.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9180",
    "data-name": "Group 9180",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    className: "cls-31",
    d: "M26.322,82.335,26.2,82.09,81.231,54.3l.122.244",
    transform: "translate(-17.832 -30.33)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9181",
    "data-name": "Group 9181",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    className: "cls-31",
    d: "M26.222,82.035,26.1,81.79,81.131,54l.122.305",
    transform: "translate(-17.793 -30.213)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9182",
    "data-name": "Group 9182",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    className: "cls-32",
    d: "M26.122,81.774,26,81.529,80.97,53.8l.122.244",
    transform: "translate(-17.755 -30.135)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9183",
    "data-name": "Group 9183",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    className: "cls-33",
    d: "M25.922,81.535l-.122-.305L80.831,53.5l.122.244",
    transform: "translate(-17.677 -30.019)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9184",
    "data-name": "Group 9184",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    className: "cls-33",
    d: "M25.822,81.235,25.7,80.99,80.731,53.2l.122.244",
    transform: "translate(-17.638 -29.902)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9185",
    "data-name": "Group 9185",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    className: "cls-34",
    d: "M25.622,80.935,25.5,80.69,80.531,52.9l.122.244",
    transform: "translate(-17.56 -29.785)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9186",
    "data-name": "Group 9186",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    className: "cls-34",
    d: "M25.522,80.674l-.122-.244L80.431,52.7l.122.244",
    transform: "translate(-17.521 -29.707)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9187",
    "data-name": "Group 9187",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    className: "cls-35",
    d: "M25.422,80.435l-.122-.305L80.27,52.4l.122.244",
    transform: "translate(-17.482 -29.59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9188",
    "data-name": "Group 9188",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    className: "cls-36",
    d: "M25.222,80.135,25.1,79.89,80.131,52.1l.122.244",
    transform: "translate(-17.404 -29.474)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9189",
    "data-name": "Group 9189",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    className: "cls-36",
    d: "M25.122,79.835,25,79.59,80.031,51.8l.122.244",
    transform: "translate(-17.365 -29.357)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9190",
    "data-name": "Group 9190",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    className: "cls-37",
    d: "M24.922,79.535,24.8,79.29,79.831,51.5l.122.305",
    transform: "translate(-17.287 -29.24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9191",
    "data-name": "Group 9191",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    className: "cls-38",
    d: "M24.822,79.274l-.122-.244L79.731,51.3l.122.244",
    transform: "translate(-17.249 -29.162)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9192",
    "data-name": "Group 9192",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    className: "cls-38",
    d: "M24.722,79.035l-.122-.305L79.57,51l.122.244",
    transform: "translate(-17.21 -29.046)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9193",
    "data-name": "Group 9193",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    className: "cls-39",
    d: "M24.522,78.735,24.4,78.49,79.431,50.7l.122.244",
    transform: "translate(-17.132 -28.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9194",
    "data-name": "Group 9194",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    className: "cls-39",
    d: "M24.422,78.435,24.3,78.19,79.331,50.4l.122.244",
    transform: "translate(-17.093 -28.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9195",
    "data-name": "Group 9195",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    className: "cls-40",
    d: "M24.222,78.174l-.122-.244L79.131,50.2l.122.244",
    transform: "translate(-17.015 -28.734)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9196",
    "data-name": "Group 9196",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    className: "cls-40",
    d: "M24.122,77.935,24,77.629,79.031,49.9l.122.244",
    transform: "translate(-16.976 -28.617)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9197",
    "data-name": "Group 9197",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    className: "cls-40",
    d: "M24.022,77.635,23.9,77.39,78.87,49.6l.122.244",
    transform: "translate(-16.937 -28.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9198",
    "data-name": "Group 9198",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    "data-name": "Path 6605",
    className: "cls-41",
    d: "M23.822,77.335,23.7,77.09,78.731,49.3l.122.244",
    transform: "translate(-16.859 -28.384)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9199",
    "data-name": "Group 9199",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    className: "cls-41",
    d: "M23.722,77.035,23.6,76.79,78.631,49l.122.305",
    transform: "translate(-16.82 -28.267)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9200",
    "data-name": "Group 9200",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6609",
    "data-name": "Path 6609",
    className: "cls-41",
    d: "M23.522,76.774l-.122-.244L78.431,48.8l.122.244",
    transform: "translate(-16.743 -28.189)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9201",
    "data-name": "Group 9201",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6611",
    "data-name": "Path 6611",
    className: "cls-42",
    d: "M23.422,76.535,23.3,76.29,78.331,48.5l.122.244",
    transform: "translate(-16.704 -28.072)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9202",
    "data-name": "Group 9202",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6613",
    "data-name": "Path 6613",
    className: "cls-42",
    d: "M23.322,76.235,23.2,75.99,78.17,48.2l.122.244",
    transform: "translate(-16.665 -27.956)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9203",
    "data-name": "Group 9203",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    "data-name": "Path 6615",
    className: "cls-42",
    d: "M23.122,75.935,23,75.69,78.031,47.9l.122.305",
    transform: "translate(-16.587 -27.839)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9204",
    "data-name": "Group 9204",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    "data-name": "Path 6617",
    className: "cls-42",
    d: "M23.022,75.674l-.122-.244L77.931,47.7l.122.244",
    transform: "translate(-16.548 -27.761)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9205",
    "data-name": "Group 9205",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    "data-name": "Path 6619",
    className: "cls-42",
    d: "M22.822,75.435l-.122-.305L77.731,47.4l.122.244",
    transform: "translate(-16.47 -27.644)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9206",
    "data-name": "Group 9206",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6621",
    "data-name": "Path 6621",
    className: "cls-43",
    d: "M22.722,75.135,22.6,74.89,77.631,47.1l.122.244",
    transform: "translate(-16.431 -27.528)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9207",
    "data-name": "Group 9207",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    "data-name": "Path 6623",
    className: "cls-43",
    d: "M22.622,74.835,22.5,74.59,77.47,46.8l.122.244",
    transform: "translate(-16.392 -27.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9208",
    "data-name": "Group 9208",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    className: "cls-43",
    d: "M22.422,74.535,22.3,74.29,77.331,46.5l.122.305",
    transform: "translate(-16.314 -27.294)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9209",
    "data-name": "Group 9209",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    className: "cls-43",
    d: "M22.322,74.274l-.122-.244L77.231,46.3l.122.244",
    transform: "translate(-16.276 -27.216)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9210",
    "data-name": "Group 9210",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    "data-name": "Path 6629",
    className: "cls-43",
    d: "M22.122,74.035,22,73.79,77.031,46l.122.244",
    transform: "translate(-16.198 -27.099)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9211",
    "data-name": "Group 9211",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    className: "cls-44",
    d: "M22.022,73.735,21.9,73.49,76.931,45.7l.122.244",
    transform: "translate(-16.159 -26.983)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9212",
    "data-name": "Group 9212",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    className: "cls-44",
    d: "M21.922,73.435,21.8,73.19,76.77,45.4l.122.305",
    transform: "translate(-16.12 -26.866)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9213",
    "data-name": "Group 9213",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    className: "cls-44",
    d: "M21.722,73.174l-.122-.244L76.631,45.2l.122.244",
    transform: "translate(-16.042 -26.788)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9214",
    "data-name": "Group 9214",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    className: "cls-44",
    d: "M21.622,72.935l-.122-.305L76.531,44.9l.122.244",
    transform: "translate(-16.003 -26.671)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9215",
    "data-name": "Group 9215",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    className: "cls-44",
    d: "M21.422,72.635,21.3,72.39,76.331,44.6l.122.244",
    transform: "translate(-15.925 -26.554)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9216",
    "data-name": "Group 9216",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    className: "cls-44",
    d: "M21.322,72.335,21.2,72.09,76.231,44.3l.122.244",
    transform: "translate(-15.886 -26.438)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9217",
    "data-name": "Group 9217",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    className: "cls-44",
    d: "M21.222,72.074l-.122-.244L76.07,44.1l.122.244",
    transform: "translate(-15.847 -26.36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9218",
    "data-name": "Group 9218",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    className: "cls-44",
    d: "M21.022,71.835l-.122-.305L75.931,43.8l.122.244",
    transform: "translate(-15.769 -26.243)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9219",
    "data-name": "Group 9219",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    className: "cls-44",
    d: "M20.922,71.535,20.8,71.29,75.77,43.5l.183.244",
    transform: "translate(-15.731 -26.126)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9220",
    "data-name": "Group 9220",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    "data-name": "Path 6649",
    className: "cls-44",
    d: "M20.722,71.235,20.6,70.99,75.631,43.2l.122.244",
    transform: "translate(-15.653 -26.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9221",
    "data-name": "Group 9221",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    className: "cls-44",
    d: "M20.622,70.935,20.5,70.69,75.531,42.9l.122.305",
    transform: "translate(-15.614 -25.893)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9222",
    "data-name": "Group 9222",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6653",
    "data-name": "Path 6653",
    className: "cls-45",
    d: "M20.522,70.674l-.122-.244L75.37,42.7l.122.244",
    transform: "translate(-15.575 -25.815)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9223",
    "data-name": "Group 9223",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    className: "cls-45",
    d: "M20.322,70.435l-.122-.305L75.231,42.4l.122.244",
    transform: "translate(-15.497 -25.698)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9224",
    "data-name": "Group 9224",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    className: "cls-45",
    d: "M20.222,70.135,20.1,69.89,75.07,42.1l.183.244",
    transform: "translate(-15.458 -25.581)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9225",
    "data-name": "Group 9225",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6659",
    "data-name": "Path 6659",
    className: "cls-45",
    d: "M20.022,69.835,19.9,69.59,74.931,41.8l.122.244",
    transform: "translate(-15.38 -25.465)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9226",
    "data-name": "Group 9226",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6661",
    "data-name": "Path 6661",
    className: "cls-45",
    d: "M19.922,69.574l-.122-.244L74.831,41.6l.122.244",
    transform: "translate(-15.341 -25.387)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9227",
    "data-name": "Group 9227",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6663",
    "data-name": "Path 6663",
    className: "cls-46",
    d: "M19.822,69.335l-.122-.305L74.67,41.3l.122.244",
    transform: "translate(-15.302 -25.27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9228",
    "data-name": "Group 9228",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6665",
    "data-name": "Path 6665",
    className: "cls-46",
    d: "M19.622,69.035,19.5,68.79,74.531,41l.122.244",
    transform: "translate(-15.225 -25.153)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9229",
    "data-name": "Group 9229",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    className: "cls-46",
    d: "M19.522,68.735,19.4,68.49,74.37,40.7l.183.244",
    transform: "translate(-15.186 -25.037)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9230",
    "data-name": "Group 9230",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6669",
    "data-name": "Path 6669",
    className: "cls-46",
    d: "M19.322,68.435,19.2,68.19,74.231,40.4l.122.305",
    transform: "translate(-15.108 -24.92)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9231",
    "data-name": "Group 9231",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6671",
    "data-name": "Path 6671",
    className: "cls-46",
    d: "M19.222,68.174l-.122-.244L74.131,40.2l.122.244",
    transform: "translate(-15.069 -24.842)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9232",
    "data-name": "Group 9232",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6673",
    "data-name": "Path 6673",
    className: "cls-47",
    d: "M19.122,67.935,19,67.69,73.97,39.9l.122.244",
    transform: "translate(-15.03 -24.725)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9233",
    "data-name": "Group 9233",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6675",
    "data-name": "Path 6675",
    className: "cls-47",
    d: "M18.922,67.635,18.8,67.39,73.831,39.6l.122.244",
    transform: "translate(-14.952 -24.608)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9234",
    "data-name": "Group 9234",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6677",
    "data-name": "Path 6677",
    className: "cls-47",
    d: "M18.822,67.335,18.7,67.09,73.67,39.3l.183.305",
    transform: "translate(-14.913 -24.492)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9235",
    "data-name": "Group 9235",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6679",
    "data-name": "Path 6679",
    className: "cls-47",
    d: "M18.622,67.074l-.122-.244L73.531,39.1l.122.244",
    transform: "translate(-14.835 -24.414)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9236",
    "data-name": "Group 9236",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6681",
    "data-name": "Path 6681",
    className: "cls-47",
    d: "M18.522,66.835l-.122-.305L73.431,38.8l.122.244",
    transform: "translate(-14.796 -24.297)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9237",
    "data-name": "Group 9237",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6683",
    "data-name": "Path 6683",
    className: "cls-48",
    d: "M18.422,66.535,18.3,66.29,73.27,38.5l.122.244",
    transform: "translate(-14.758 -24.18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9238",
    "data-name": "Group 9238",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6685",
    "data-name": "Path 6685",
    className: "cls-48",
    d: "M18.222,66.235,18.1,65.99,73.131,38.2l.122.244",
    transform: "translate(-14.68 -24.063)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9239",
    "data-name": "Group 9239",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    "data-name": "Path 6687",
    className: "cls-48",
    d: "M18.122,65.935,18,65.69,72.97,37.9l.183.305",
    transform: "translate(-14.641 -23.947)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9240",
    "data-name": "Group 9240",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    className: "cls-48",
    d: "M17.922,65.674l-.122-.244L72.831,37.7l.122.244",
    transform: "translate(-14.563 -23.869)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9241",
    "data-name": "Group 9241",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6691",
    "data-name": "Path 6691",
    className: "cls-48",
    d: "M17.822,65.435,17.7,65.19,72.731,37.4l.122.244",
    transform: "translate(-14.524 -23.752)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9242",
    "data-name": "Group 9242",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6693",
    "data-name": "Path 6693",
    className: "cls-48",
    d: "M17.722,65.135,17.6,64.89,72.57,37.1l.122.244",
    transform: "translate(-14.485 -23.635)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    className: "cls-48",
    d: "M17.522,64.835,17.4,64.59,72.431,36.8l.122.305",
    transform: "translate(-14.407 -23.519)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9244",
    "data-name": "Group 9244",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    className: "cls-48",
    d: "M17.422,64.574l-.122-.244L72.27,36.6l.183.244",
    transform: "translate(-14.368 -23.441)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9245",
    "data-name": "Group 9245",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6699",
    "data-name": "Path 6699",
    className: "cls-48",
    d: "M17.222,64.335l-.122-.305L72.131,36.3l.122.244",
    transform: "translate(-14.29 -23.324)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9246",
    "data-name": "Group 9246",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6701",
    "data-name": "Path 6701",
    className: "cls-48",
    d: "M17.122,64.035,17,63.79,72.031,36l.122.244",
    transform: "translate(-14.252 -23.207)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9247",
    "data-name": "Group 9247",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6703",
    "data-name": "Path 6703",
    className: "cls-49",
    d: "M17.022,63.735,16.9,63.49,71.87,35.7l.122.244",
    transform: "translate(-14.213 -23.09)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9248",
    "data-name": "Group 9248",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6705",
    "data-name": "Path 6705",
    className: "cls-49",
    d: "M16.822,63.474l-.122-.244L71.731,35.5l.122.244",
    transform: "translate(-14.135 -23.013)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9249",
    "data-name": "Group 9249",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6707",
    "data-name": "Path 6707",
    className: "cls-49",
    d: "M16.722,63.235l-.122-.305L71.57,35.2l.183.244",
    transform: "translate(-14.096 -22.896)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9250",
    "data-name": "Group 9250",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6709",
    "data-name": "Path 6709",
    className: "cls-49",
    d: "M16.522,62.935,16.4,62.69,71.431,34.9l.122.244",
    transform: "translate(-14.018 -22.779)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9251",
    "data-name": "Group 9251",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6711",
    "data-name": "Path 6711",
    className: "cls-49",
    d: "M16.422,62.635,16.3,62.39,71.331,34.6l.122.244",
    transform: "translate(-13.979 -22.662)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9252",
    "data-name": "Group 9252",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6713",
    "data-name": "Path 6713",
    className: "cls-50",
    d: "M16.322,62.335,16.2,62.09,71.17,34.3l.122.305",
    transform: "translate(-13.94 -22.545)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9253",
    "data-name": "Group 9253",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6715",
    "data-name": "Path 6715",
    className: "cls-50",
    d: "M16.122,62.074,16,61.829,71.031,34.1l.122.244",
    transform: "translate(-13.862 -22.468)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9254",
    "data-name": "Group 9254",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6717",
    "data-name": "Path 6717",
    className: "cls-50",
    d: "M16.022,61.835l-.122-.305L70.87,33.8l.183.244",
    transform: "translate(-13.823 -22.351)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9255",
    "data-name": "Group 9255",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6719",
    "data-name": "Path 6719",
    className: "cls-50",
    d: "M15.822,61.535,15.7,61.29,70.731,33.5l.122.244",
    transform: "translate(-13.746 -22.234)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9256",
    "data-name": "Group 9256",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6721",
    "data-name": "Path 6721",
    className: "cls-50",
    d: "M15.722,61.235,15.6,60.99,70.631,33.2l.122.244",
    transform: "translate(-13.707 -22.117)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9257",
    "data-name": "Group 9257",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6723",
    "data-name": "Path 6723",
    className: "cls-51",
    d: "M15.622,60.974l-.122-.244L70.47,33l.122.244",
    transform: "translate(-13.668 -22.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9258",
    "data-name": "Group 9258",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6725",
    "data-name": "Path 6725",
    className: "cls-51",
    d: "M15.422,60.735l-.122-.305L70.331,32.7l.122.244",
    transform: "translate(-13.59 -21.923)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9259",
    "data-name": "Group 9259",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6727",
    "data-name": "Path 6727",
    className: "cls-51",
    d: "M15.322,60.435,15.2,60.19,70.17,32.4l.183.244",
    transform: "translate(-13.551 -21.806)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9260",
    "data-name": "Group 9260",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6729",
    "data-name": "Path 6729",
    className: "cls-51",
    d: "M15.122,60.135,15,59.89,70.031,32.1l.122.244",
    transform: "translate(-13.473 -21.689)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9261",
    "data-name": "Group 9261",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6731",
    "data-name": "Path 6731",
    className: "cls-51",
    d: "M15.022,59.835,14.9,59.59,69.931,31.8l.122.305",
    transform: "translate(-13.434 -21.572)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9262",
    "data-name": "Group 9262",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6733",
    "data-name": "Path 6733",
    className: "cls-52",
    d: "M14.922,59.574l-.122-.244L69.77,31.6l.122.244",
    transform: "translate(-13.395 -21.495)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9263",
    "data-name": "Group 9263",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6735",
    "data-name": "Path 6735",
    className: "cls-52",
    d: "M14.722,59.335,14.6,59.09,69.631,31.3l.122.244",
    transform: "translate(-13.317 -21.378)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9264",
    "data-name": "Group 9264",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6737",
    "data-name": "Path 6737",
    className: "cls-52",
    d: "M14.622,59.035,14.5,58.79,69.47,31l.183.244",
    transform: "translate(-13.278 -21.261)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9265",
    "data-name": "Group 9265",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6739",
    "data-name": "Path 6739",
    className: "cls-52",
    d: "M14.422,58.735,14.3,58.49,69.331,30.7l.122.305",
    transform: "translate(-13.201 -21.144)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9266",
    "data-name": "Group 9266",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6741",
    "data-name": "Path 6741",
    className: "cls-52",
    d: "M14.322,58.474l-.122-.244L69.231,30.5l.122.244",
    transform: "translate(-13.162 -21.066)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9267",
    "data-name": "Group 9267",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6743",
    "data-name": "Path 6743",
    className: "cls-52",
    d: "M14.222,58.235l-.122-.305L69.07,30.2l.122.244",
    transform: "translate(-13.123 -20.95)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9268",
    "data-name": "Group 9268",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6745",
    "data-name": "Path 6745",
    className: "cls-53",
    d: "M14.022,57.935,13.9,57.69,68.931,29.9l.122.244",
    transform: "translate(-13.045 -20.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9269",
    "data-name": "Group 9269",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6747",
    "data-name": "Path 6747",
    className: "cls-53",
    d: "M13.922,57.635,13.8,57.39,68.77,29.6l.183.244",
    transform: "translate(-13.006 -20.716)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9270",
    "data-name": "Group 9270",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6749",
    "data-name": "Path 6749",
    className: "cls-53",
    d: "M13.722,57.335,13.6,57.09,68.631,29.3l.122.305",
    transform: "translate(-12.928 -20.599)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9271",
    "data-name": "Group 9271",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6751",
    "data-name": "Path 6751",
    className: "cls-53",
    d: "M13.622,57.074l-.122-.244L68.531,29.1l.122.244",
    transform: "translate(-12.889 -20.522)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9272",
    "data-name": "Group 9272",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6753",
    "data-name": "Path 6753",
    className: "cls-53",
    d: "M13.522,56.835,13.4,56.59,68.37,28.8l.122.244",
    transform: "translate(-12.85 -20.405)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9273",
    "data-name": "Group 9273",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6755",
    "data-name": "Path 6755",
    className: "cls-54",
    d: "M13.322,56.535,13.2,56.29,68.231,28.5l.122.244",
    transform: "translate(-12.772 -20.288)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9274",
    "data-name": "Group 9274",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6757",
    "data-name": "Path 6757",
    className: "cls-54",
    d: "M13.222,56.235,13.1,55.99,68.07,28.2l.183.305",
    transform: "translate(-12.734 -20.171)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9275",
    "data-name": "Group 9275",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6759",
    "data-name": "Path 6759",
    className: "cls-54",
    d: "M13.022,55.974l-.122-.244L67.931,28l.122.244",
    transform: "translate(-12.656 -20.093)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9276",
    "data-name": "Group 9276",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6761",
    "data-name": "Path 6761",
    className: "cls-54",
    d: "M12.922,55.735l-.122-.305L67.831,27.7l.122.244",
    transform: "translate(-12.617 -19.977)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9277",
    "data-name": "Group 9277",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6763",
    "data-name": "Path 6763",
    className: "cls-54",
    d: "M12.822,55.435,12.7,55.19,67.67,27.4l.122.244",
    transform: "translate(-12.578 -19.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9278",
    "data-name": "Group 9278",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6765",
    "data-name": "Path 6765",
    className: "cls-55",
    d: "M12.622,55.135,12.5,54.89,67.531,27.1l.122.244",
    transform: "translate(-12.5 -19.743)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9279",
    "data-name": "Group 9279",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6767",
    "data-name": "Path 6767",
    className: "cls-55",
    d: "M12.522,54.874l-.122-.244L67.37,26.9l.183.244",
    transform: "translate(-12.461 -19.665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9280",
    "data-name": "Group 9280",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6769",
    "data-name": "Path 6769",
    className: "cls-55",
    d: "M12.322,54.635l-.122-.305L67.231,26.6l.122.244",
    transform: "translate(-12.383 -19.548)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9281",
    "data-name": "Group 9281",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6771",
    "data-name": "Path 6771",
    className: "cls-55",
    d: "M12.222,54.335,12.1,54.09,67.131,26.3l.122.244",
    transform: "translate(-12.344 -19.432)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9282",
    "data-name": "Group 9282",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6773",
    "data-name": "Path 6773",
    className: "cls-55",
    d: "M12.122,54.035,12,53.79,66.97,26l.122.244",
    transform: "translate(-12.305 -19.315)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9283",
    "data-name": "Group 9283",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6775",
    "data-name": "Path 6775",
    className: "cls-56",
    d: "M11.922,53.735,11.8,53.49,66.831,25.7l.122.305",
    transform: "translate(-12.228 -19.198)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9284",
    "data-name": "Group 9284",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6777",
    "data-name": "Path 6777",
    className: "cls-56",
    d: "M11.822,53.474l-.122-.244L66.67,25.5l.183.244",
    transform: "translate(-12.189 -19.12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9285",
    "data-name": "Group 9285",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6779",
    "data-name": "Path 6779",
    className: "cls-56",
    d: "M11.622,53.235l-.122-.305L66.531,25.2l.122.244",
    transform: "translate(-12.111 -19.004)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9286",
    "data-name": "Group 9286",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6781",
    "data-name": "Path 6781",
    className: "cls-56",
    d: "M11.522,52.935,11.4,52.69,66.431,24.9l.122.244",
    transform: "translate(-12.072 -18.887)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9287",
    "data-name": "Group 9287",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6783",
    "data-name": "Path 6783",
    className: "cls-56",
    d: "M11.422,52.635,11.3,52.39,66.27,24.6l.122.244",
    transform: "translate(-12.033 -18.77)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9288",
    "data-name": "Group 9288",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6785",
    "data-name": "Path 6785",
    className: "cls-56",
    d: "M11.222,52.374l-.122-.244L66.131,24.4l.122.244",
    transform: "translate(-11.955 -18.692)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9289",
    "data-name": "Group 9289",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    "data-name": "Path 6787",
    className: "cls-56",
    d: "M11.122,52.135,11,51.829,65.97,24.1l.183.244",
    transform: "translate(-11.916 -18.575)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9290",
    "data-name": "Group 9290",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    "data-name": "Path 6789",
    className: "cls-56",
    d: "M10.922,51.835,10.8,51.59,65.831,23.8l.122.244",
    transform: "translate(-11.838 -18.459)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9291",
    "data-name": "Group 9291",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6791",
    "data-name": "Path 6791",
    className: "cls-56",
    d: "M10.822,51.535,10.7,51.29,65.731,23.5l.122.244",
    transform: "translate(-11.799 -18.342)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9292",
    "data-name": "Group 9292",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    "data-name": "Path 6793",
    className: "cls-56",
    d: "M10.722,51.235,10.6,50.99,65.57,23.2l.122.305",
    transform: "translate(-11.76 -18.225)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9293",
    "data-name": "Group 9293",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6795",
    "data-name": "Path 6795",
    className: "cls-57",
    d: "M10.522,50.974l-.122-.244L65.431,23l.122.244",
    transform: "translate(-11.683 -18.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9294",
    "data-name": "Group 9294",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6797",
    "data-name": "Path 6797",
    className: "cls-57",
    d: "M10.422,50.735,10.3,50.49,65.27,22.7l.183.244",
    transform: "translate(-11.644 -18.03)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9295",
    "data-name": "Group 9295",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6799",
    "data-name": "Path 6799",
    className: "cls-57",
    d: "M10.222,50.435,10.1,50.19,65.131,22.4l.122.244",
    transform: "translate(-11.566 -17.914)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9296",
    "data-name": "Group 9296",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6801",
    "data-name": "Path 6801",
    className: "cls-57",
    d: "M10.122,50.135,10,49.89,65.031,22.1l.122.305",
    transform: "translate(-11.527 -17.797)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9297",
    "data-name": "Group 9297",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6803",
    "data-name": "Path 6803",
    className: "cls-57",
    d: "M10.022,49.874,9.9,49.629,64.87,21.9l.122.244",
    transform: "translate(-11.488 -17.719)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9298",
    "data-name": "Group 9298",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6805",
    "data-name": "Path 6805",
    className: "cls-58",
    d: "M9.822,49.635,9.7,49.329,64.731,21.6l.122.244",
    transform: "translate(-11.41 -17.602)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9299",
    "data-name": "Group 9299",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    className: "cls-58",
    d: "M9.722,49.335,9.6,49.09,64.57,21.3l.183.244",
    transform: "translate(-11.371 -17.486)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9300",
    "data-name": "Group 9300",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    "data-name": "Path 6809",
    className: "cls-58",
    d: "M9.522,49.035,9.4,48.79,64.431,21l.122.244",
    transform: "translate(-11.293 -17.369)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9301",
    "data-name": "Group 9301",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6811",
    "data-name": "Path 6811",
    className: "cls-58",
    d: "M9.422,48.735,9.3,48.49,64.331,20.7l.122.305",
    transform: "translate(-11.254 -17.252)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9302",
    "data-name": "Group 9302",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6813",
    "data-name": "Path 6813",
    className: "cls-58",
    d: "M9.322,48.474,9.2,48.229,64.17,20.5l.122.244",
    transform: "translate(-11.216 -17.174)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9303",
    "data-name": "Group 9303",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6815",
    "data-name": "Path 6815",
    className: "cls-59",
    d: "M9.122,48.235,9,47.99,64.031,20.2l.122.244",
    transform: "translate(-11.138 -17.057)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9304",
    "data-name": "Group 9304",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6817",
    "data-name": "Path 6817",
    className: "cls-59",
    d: "M9.022,47.935,8.9,47.69,63.87,19.9l.183.244",
    transform: "translate(-11.099 -16.941)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9305",
    "data-name": "Group 9305",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6819",
    "data-name": "Path 6819",
    className: "cls-59",
    d: "M8.822,47.635,8.7,47.39,63.731,19.6l.122.305",
    transform: "translate(-11.021 -16.824)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9306",
    "data-name": "Group 9306",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    className: "cls-59",
    d: "M8.722,47.374,8.6,47.129,63.631,19.4l.122.244",
    transform: "translate(-10.982 -16.746)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9307",
    "data-name": "Group 9307",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6823",
    "data-name": "Path 6823",
    className: "cls-59",
    d: "M8.622,47.135,8.5,46.829,63.47,19.1l.122.244",
    transform: "translate(-10.943 -16.629)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9308",
    "data-name": "Group 9308",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6825",
    "data-name": "Path 6825",
    className: "cls-60",
    d: "M8.422,46.835,8.3,46.59,63.331,18.8l.122.244",
    transform: "translate(-10.865 -16.513)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9309",
    "data-name": "Group 9309",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6827",
    "data-name": "Path 6827",
    className: "cls-60",
    d: "M8.322,46.535,8.2,46.29,63.17,18.5l.183.244",
    transform: "translate(-10.826 -16.396)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9310",
    "data-name": "Group 9310",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6829",
    "data-name": "Path 6829",
    className: "cls-60",
    d: "M8.122,46.274,8,46.029,63.031,18.3l.122.244",
    transform: "translate(-10.748 -16.318)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9311",
    "data-name": "Group 9311",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6831",
    "data-name": "Path 6831",
    className: "cls-60",
    d: "M8.022,46.035,7.9,45.729,62.931,18l.122.244",
    transform: "translate(-10.71 -16.201)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9312",
    "data-name": "Group 9312",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6833",
    "data-name": "Path 6833",
    className: "cls-60",
    d: "M7.922,45.735,7.8,45.49,62.77,17.7l.122.244",
    transform: "translate(-10.671 -16.084)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9313",
    "data-name": "Group 9313",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6835",
    "data-name": "Path 6835",
    className: "cls-60",
    d: "M7.722,45.435,7.6,45.19,62.631,17.4l.122.244",
    transform: "translate(-10.593 -15.968)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9314",
    "data-name": "Group 9314",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6837",
    "data-name": "Path 6837",
    className: "cls-60",
    d: "M7.622,45.135,7.5,44.89,62.47,17.1l.183.305",
    transform: "translate(-10.554 -15.851)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9315",
    "data-name": "Group 9315",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6839",
    "data-name": "Path 6839",
    className: "cls-60",
    d: "M7.422,44.874,7.3,44.629,62.331,16.9l.122.244",
    transform: "translate(-10.476 -15.773)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9316",
    "data-name": "Group 9316",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6841",
    "data-name": "Path 6841",
    className: "cls-60",
    d: "M7.322,44.635,7.2,44.329,62.231,16.6l.122.244",
    transform: "translate(-10.437 -15.656)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9317",
    "data-name": "Group 9317",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6843",
    "data-name": "Path 6843",
    className: "cls-60",
    d: "M7.222,44.335,7.1,44.09,62.07,16.3l.122.244",
    transform: "translate(-10.398 -15.539)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9318",
    "data-name": "Group 9318",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6845",
    "data-name": "Path 6845",
    className: "cls-60",
    d: "M7.022,44.035,6.9,43.79,61.931,16l.122.244",
    transform: "translate(-10.32 -15.423)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9319",
    "data-name": "Group 9319",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6847",
    "data-name": "Path 6847",
    className: "cls-61",
    d: "M6.922,43.774,6.8,43.529,61.77,15.8l.183.244",
    transform: "translate(-10.281 -15.345)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9320",
    "data-name": "Group 9320",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6849",
    "data-name": "Path 6849",
    className: "cls-61",
    d: "M6.722,43.535,6.6,43.229,61.631,15.5l.122.244",
    transform: "translate(-10.204 -15.228)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9321",
    "data-name": "Group 9321",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6851",
    "data-name": "Path 6851",
    className: "cls-61",
    d: "M6.622,43.235,6.5,42.99,61.531,15.2l.122.244",
    transform: "translate(-10.165 -15.111)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9322",
    "data-name": "Group 9322",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6853",
    "data-name": "Path 6853",
    className: "cls-61",
    d: "M6.522,42.935,6.4,42.69,61.37,14.9l.122.244",
    transform: "translate(-10.126 -14.995)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9323",
    "data-name": "Group 9323",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6855",
    "data-name": "Path 6855",
    className: "cls-61",
    d: "M6.322,42.635,6.2,42.39,61.231,14.6l.122.305",
    transform: "translate(-10.048 -14.878)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9324",
    "data-name": "Group 9324",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6857",
    "data-name": "Path 6857",
    className: "cls-62",
    d: "M6.222,42.374,6.1,42.129,61.07,14.4l.183.244",
    transform: "translate(-10.009 -14.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9325",
    "data-name": "Group 9325",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6859",
    "data-name": "Path 6859",
    className: "cls-62",
    d: "M6.022,42.135,5.9,41.89,60.931,14.1l.122.244",
    transform: "translate(-9.931 -14.683)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9326",
    "data-name": "Group 9326",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6861",
    "data-name": "Path 6861",
    className: "cls-62",
    d: "M5.922,41.835,5.8,41.59,60.831,13.8l.122.244",
    transform: "translate(-9.892 -14.566)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9327",
    "data-name": "Group 9327",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6863",
    "data-name": "Path 6863",
    className: "cls-62",
    d: "M5.822,41.535,5.7,41.29,60.67,13.5l.122.305",
    transform: "translate(-9.853 -14.45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9328",
    "data-name": "Group 9328",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6865",
    "data-name": "Path 6865",
    className: "cls-62",
    d: "M5.622,41.274,5.5,41.029,60.531,13.3l.122.244",
    transform: "translate(-9.775 -14.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9329",
    "data-name": "Group 9329",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6867",
    "data-name": "Path 6867",
    className: "cls-63",
    d: "M5.522,41.035,5.4,40.729,60.37,13l.183.244",
    transform: "translate(-9.736 -14.255)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9330",
    "data-name": "Group 9330",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6869",
    "data-name": "Path 6869",
    className: "cls-63",
    d: "M5.322,40.735,5.2,40.49,60.231,12.7l.122.244",
    transform: "translate(-9.659 -14.138)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9331",
    "data-name": "Group 9331",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6871",
    "data-name": "Path 6871",
    className: "cls-63",
    d: "M5.222,40.435,5.1,40.19,60.131,12.4l.122.244",
    transform: "translate(-9.62 -14.021)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9332",
    "data-name": "Group 9332",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6873",
    "data-name": "Path 6873",
    className: "cls-63",
    d: "M5.122,40.135,5,39.89,59.97,12.1l.122.305",
    transform: "translate(-9.581 -13.905)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9333",
    "data-name": "Group 9333",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6875",
    "data-name": "Path 6875",
    className: "cls-63",
    d: "M4.922,39.874,4.8,39.629,59.831,11.9l.122.244",
    transform: "translate(-9.503 -13.827)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9334",
    "data-name": "Group 9334",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6877",
    "data-name": "Path 6877",
    className: "cls-64",
    d: "M4.822,39.635,4.7,39.39,59.67,11.6l.183.244",
    transform: "translate(-9.464 -13.71)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9335",
    "data-name": "Group 9335",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6879",
    "data-name": "Path 6879",
    className: "cls-64",
    d: "M4.622,39.335,4.5,39.09,59.531,11.3l.122.244",
    transform: "translate(-9.386 -13.593)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9336",
    "data-name": "Group 9336",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6881",
    "data-name": "Path 6881",
    className: "cls-64",
    d: "M4.522,39.035,4.4,38.79,59.431,11l.122.305",
    transform: "translate(-9.347 -13.477)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9337",
    "data-name": "Group 9337",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6883",
    "data-name": "Path 6883",
    className: "cls-64",
    d: "M4.422,38.774,4.3,38.529,59.27,10.8l.122.244",
    transform: "translate(-9.308 -13.399)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9338",
    "data-name": "Group 9338",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6885",
    "data-name": "Path 6885",
    className: "cls-64",
    d: "M4.222,38.535,4.1,38.229,59.131,10.5l.122.244",
    transform: "translate(-9.231 -13.282)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9339",
    "data-name": "Group 9339",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6887",
    "data-name": "Path 6887",
    className: "cls-65",
    d: "M4.122,38.235,4,37.99,58.97,10.2l.183.244",
    transform: "translate(-9.192 -13.165)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9340",
    "data-name": "Group 9340",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6889",
    "data-name": "Path 6889",
    className: "cls-65",
    d: "M3.922,37.935,3.8,37.69,58.831,9.9l.122.244",
    transform: "translate(-9.114 -13.048)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9341",
    "data-name": "Group 9341",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6891",
    "data-name": "Path 6891",
    className: "cls-65",
    d: "M3.822,37.674,3.7,37.429,58.731,9.7l.122.244",
    transform: "translate(-9.075 -12.971)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9342",
    "data-name": "Group 9342",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6893",
    "data-name": "Path 6893",
    className: "cls-65",
    d: "M3.722,37.435,3.6,37.129,58.57,9.4l.122.244",
    transform: "translate(-9.036 -12.854)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9343",
    "data-name": "Group 9343",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6895",
    "data-name": "Path 6895",
    className: "cls-65",
    d: "M3.522,37.135,3.4,36.89,58.431,9.1l.122.244",
    transform: "translate(-8.958 -12.737)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9344",
    "data-name": "Group 9344",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6897",
    "data-name": "Path 6897",
    className: "cls-66",
    d: "M3.422,36.835,3.3,36.59,58.27,8.8l.183.244",
    transform: "translate(-8.919 -12.62)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9345",
    "data-name": "Group 9345",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6899",
    "data-name": "Path 6899",
    className: "cls-66",
    d: "M3.222,36.535,3.1,36.29,58.131,8.5l.122.305",
    transform: "translate(-8.841 -12.503)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9346",
    "data-name": "Group 9346",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6901",
    "data-name": "Path 6901",
    className: "cls-66",
    d: "M3.122,36.274,3,36.029,58.031,8.3l.122.244",
    transform: "translate(-8.802 -12.426)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9347",
    "data-name": "Group 9347",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6903",
    "data-name": "Path 6903",
    className: "cls-66",
    d: "M3.022,36.035,2.9,35.729,57.87,8l.122.244",
    transform: "translate(-8.763 -12.309)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9348",
    "data-name": "Group 9348",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6905",
    "data-name": "Path 6905",
    className: "cls-66",
    d: "M2.822,35.735,2.7,35.49,57.731,7.7l.122.244",
    transform: "translate(-8.686 -12.192)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9349",
    "data-name": "Group 9349",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6907",
    "data-name": "Path 6907",
    className: "cls-67",
    d: "M2.722,35.435,2.6,35.19,57.57,7.4l.183.244",
    transform: "translate(-8.647 -12.075)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9350",
    "data-name": "Group 9350",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    className: "cls-67",
    d: "M2.522,35.174,2.4,34.929,57.431,7.2l.122.244",
    transform: "translate(-8.569 -11.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9351",
    "data-name": "Group 9351",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    className: "cls-67",
    d: "M2.422,34.935,2.3,34.629,57.331,6.9l.122.244",
    transform: "translate(-8.53 -11.881)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9352",
    "data-name": "Group 9352",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6913",
    "data-name": "Path 6913",
    className: "cls-67",
    d: "M2.322,34.635,2.2,34.39,57.17,6.6l.122.244",
    transform: "translate(-8.491 -11.764)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9353",
    "data-name": "Group 9353",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6915",
    "data-name": "Path 6915",
    className: "cls-67",
    d: "M2.122,34.335,2,34.09,57.031,6.3l.122.244",
    transform: "translate(-8.413 -11.647)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9354",
    "data-name": "Group 9354",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6917",
    "data-name": "Path 6917",
    className: "cls-68",
    d: "M2.022,34.035,1.9,33.79,56.87,6l.183.305",
    transform: "translate(-8.374 -11.53)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9355",
    "data-name": "Group 9355",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6919",
    "data-name": "Path 6919",
    className: "cls-68",
    d: "M1.822,33.774,1.7,33.529,56.731,5.8l.122.244",
    transform: "translate(-8.296 -11.453)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9356",
    "data-name": "Group 9356",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6921",
    "data-name": "Path 6921",
    className: "cls-68",
    d: "M1.722,33.535,1.6,33.29,56.631,5.5l.122.244",
    transform: "translate(-8.257 -11.336)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9357",
    "data-name": "Group 9357",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6923",
    "data-name": "Path 6923",
    className: "cls-68",
    d: "M1.622,33.235,1.5,32.99,56.47,5.2l.122.244",
    transform: "translate(-8.219 -11.219)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9358",
    "data-name": "Group 9358",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6925",
    "data-name": "Path 6925",
    className: "cls-68",
    d: "M1.422,32.935,1.3,32.69,56.331,4.9l.122.305",
    transform: "translate(-8.141 -11.102)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9359",
    "data-name": "Group 9359",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6927",
    "data-name": "Path 6927",
    className: "cls-69",
    d: "M1.322,32.674,1.2,32.429,56.17,4.7l.183.244",
    transform: "translate(-8.102 -11.024)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9360",
    "data-name": "Group 9360",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6929",
    "data-name": "Path 6929",
    className: "cls-69",
    d: "M1.122,32.435,1,32.129,56.031,4.4l.122.244",
    transform: "translate(-8.024 -10.908)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9361",
    "data-name": "Group 9361",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6931",
    "data-name": "Path 6931",
    className: "cls-69",
    d: "M1.022,32.135.9,31.89,55.931,4.1l.122.244",
    transform: "translate(-7.985 -10.791)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9362",
    "data-name": "Group 9362",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6933",
    "data-name": "Path 6933",
    className: "cls-69",
    d: "M.922,31.835.8,31.59,55.77,3.8l.122.244",
    transform: "translate(-7.946 -10.674)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9363",
    "data-name": "Group 9363",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6935",
    "data-name": "Path 6935",
    className: "cls-69",
    d: "M.722,31.535.6,31.29,55.631,3.5l.122.305",
    transform: "translate(-7.868 -10.557)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9364",
    "data-name": "Group 9364",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6937",
    "data-name": "Path 6937",
    className: "cls-70",
    d: "M.622,31.274.5,31.029,55.47,3.3l.183.244",
    transform: "translate(-7.829 -10.48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9365",
    "data-name": "Group 9365",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6939",
    "data-name": "Path 6939",
    className: "cls-70",
    d: "M.422,31.035.3,30.79,55.331,3l.122.244",
    transform: "translate(-7.751 -10.363)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9366",
    "data-name": "Group 9366",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6941",
    "data-name": "Path 6941",
    className: "cls-70",
    d: "M.322,30.735.2,30.49,55.231,2.7l.122.244",
    transform: "translate(-7.713 -10.246)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9367",
    "data-name": "Group 9367",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6943",
    "data-name": "Path 6943",
    className: "cls-70",
    d: "M.222,30.435.1,30.19,55.07,2.4l.122.305",
    transform: "translate(-7.674 -10.129)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9368",
    "data-name": "Group 9368",
    className: "cls-8",
    transform: "translate(0.003 9.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6945",
    "data-name": "Path 6945",
    className: "cls-70",
    d: "M.061,30.212,0,30.09,55.031,2.3l.061.183",
    transform: "translate(-7.635 -10.09)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignstudiologo);
export default __webpack_public_path__ + "static/media/designstudiologo.df6bdecfa02c91d3dac0dc078688b7ac.svg";
export { ForwardRef as ReactComponent };